/* eslint-disable no-unused-vars */
import { ControllerModel } from "../_model/ControllerModel";
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import { CellFactory } from "./modelCellFactory";

class ControllerCellFactory extends ControllerModel {
    constructor() {
        super("ControllerCellFactory");

        this.setNewNode = (callback) => {
            let cellfactory = new CellFactory();
            cellfactory.decorate(callback);

            this.addNode(cellfactory);
            SingletonFlowchart.SaveStatus()
        }

        this.loadNode = (node, callback) => {
            let cellfactory = new CellFactory();
            cellfactory.copyFrom(node);
            cellfactory.decorate(callback);
            this.addNode(cellfactory)
        }

        this.getProperties = async (node) => {
            let n = new CellFactory();
            await n.copyFrom(node);
            return n.data
        }

        this.getNode = (node) => {
            let n = new CellFactory();
            n.copyFrom(node);
            return n
        }
    }
}

export { ControllerCellFactory };